<div [innerHTML]="htmlString" class="h-full space-y-6"></div>
